import {IServiceFamilyConfig} from "@/model/ServiceFamilyConfig"

export interface IHasServiceFamilyConfig {
    getServiceFamilyConfig(): IServiceFamilyConfig | null
    setServiceFamilyConfig(config: IServiceFamilyConfig): void
    isEmbedded(): boolean
}

function hasServiceFamilyConfig<TBase extends Constructor>(Base: TBase) {
    return class extends Base implements IHasServiceFamilyConfig {
        private config: IServiceFamilyConfig | null = null

        constructor(...args: any[]) {
            super(...args);
        }

        public getServiceFamilyConfig(): IServiceFamilyConfig | null {
            return this.config
        }
        public setServiceFamilyConfig(config: IServiceFamilyConfig): void {
            this.config = config
        }

        public isEmbedded(): boolean {
            return !this.config
        }
    }
}

export default hasServiceFamilyConfig